const BOX = {
  SET_BOX_DATA: 'box/set_data',
};

const initialState = {
  currentBox: undefined,
  season: undefined,
  shiplist: [],
  boxItems: [],
  boxAddons: [],
  boxAdditionalChoices: [],
};

export const setBoxData = (data) => ({
  type: BOX.SET_BOX_DATA,
  payload: data,
});

const boxReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case BOX.SET_BOX_DATA:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};

export default boxReducer;
